module.exports = __webpack_public_path__ + "static/media/17_r_stena82.97_0.d203b95f.png";